/* Resources */
import {deceasedOrder} from "../../../helper/orders";
/* Contexts */
/* Components */
import Dashboard from "../../../components/common/dashboard/Dashboard";
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import SearchBox from "../../../components/common/SearchBox";
import {getAdminDeceasedList} from "../../../api/pro/deceasedReq";
import useAuth from "../../../hooks/useAuth";
import {useEffect, useRef, useState} from "react";
import usePager from "../../../hooks/usePager";
import useData from "../../../hooks/useData";

export default function Deceased() {
    const sources = "fa fa-list";
    const {dataList, setDataList} = useData();
    const [ filterParams, setFilterParams ] = useState();
    const [ totalItems, setTotalItems ] = useState();
    const { currentPage, setCurrentPage, setTotalPages, itemsPerPage } = usePager();
    const [ dateFilter, setDateFilter ] = useState('all');

    const { auth } = useAuth();
    const token= auth.token;
    const requestIdRef = useRef(0);

    const deceasedListAdminApi = async () => {
        // Un changement rapide de filtre/page peut faire arriver les réponses dans le désordre :
        // on ignore toute réponse qui n'est plus la dernière requête lancée, pour ne pas afficher
        // une liste correspondant à un filtre déjà abandonné.
        const requestId = ++requestIdRef.current;
        const response = await getAdminDeceasedList(token, currentPage, itemsPerPage, JSON.stringify(filterParams), dateFilter)
        if (requestId !== requestIdRef.current) {
            return;
        }
        setDataList(response?.deceasedList);
        setTotalItems(response?.totalItems);
        setTotalPages(Math.ceil(response?.totalItems / itemsPerPage))
    };

    const handleFilterDeceased = async (e) => {
        e.preventDefault();
        setDateFilter(e.target.value)
        setCurrentPage(1)
    }

    useEffect(() => {
        setTotalPages(Math.ceil(totalItems / itemsPerPage))
    }, [ totalItems, itemsPerPage ]);

    useEffect(() => {
        deceasedListAdminApi()
    }, [ filterParams, currentPage, itemsPerPage, dateFilter ]);

    useEffect(() => {
        setCurrentPage(1)
    }, [ filterParams, dateFilter ]);

    const headers = [
        { label: "Id", key : "id" },
        { label: "Agence", key : "agency" },
        { label: "Nom", key : "lastName" },
        { label :"Prénom", key : "firstName" },
        { label :"Date de décès", key : "deathDate" },
    ];

    return (
        <main className="admin">
            <Header parent="Administration"
                    location="Défunts"
                    slug="/admin/accueil"
            />
            <div className="content-container">
                <Icon source={ sources } color="blue" span="Liste des défunts"/>
                <SearchBox location="Défunts" headers={headers} filename="Défunts"
                   dataObject={dataList || []} setFilterParams={setFilterParams}
                />
                <div className="dashboard">
                    <div className="flex">
                        <div className="form-input">
                            <label>Filtrer les défunts</label>
                            <select onChange={handleFilterDeceased} name="filter">
                                <option value="all">Tous les défunts</option>
                                <option value="now">Ce mois-ci</option>
                                <option value="before">Le mois dernier</option>
                            </select>
                        </div>

                    </div>
                    { dataList?.length > 0 ?
                        <Dashboard totalItems={totalItems} location="Défunts" dataObject={dataList || []} order={deceasedOrder}/>
                        : <table><thead className="admin"><th><i className="fa fa-warning"/> Aucun défunt trouvé avec le filtre sélectionné</th></thead></table>
                    }
                </div>
            </div>
        </main>
    )
}